import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

export const constantRouterMap = [
	{
		path: '/',
		redirect: '/pokemonRandom'
	},
	{
		path: '/index',
		component: resolve => require(['../components/index.vue'], resolve),
		meta: { title: '首页' },
		children: [
			{
				path: '/pokemonRandom',
				component: resolve => require(['../components/common/pokemonRandom.vue'], resolve),
				meta: { title: '随机精灵' },
			},
			{
				path: '/pokemonBadge',
				component: resolve => require(['../components/common/pokemonBadge.vue'], resolve),
				meta: { title: '宝可梦徽章' },
			},
			{
				path: '/pokemonSkills',
				component: resolve => require(['../components/common/pokemonSkills.vue'], resolve),
				meta: { title: '宝可梦技能' },
			},
			{
				path: '/pokemonIntro',
				component: resolve => require(['../components/common/pokemonIntro.vue'], resolve),
				meta: { title: '宝可梦介绍' },
			},
			,
			{
				path: '/pokemonItem',
				component: resolve => require(['../components/common/pokemonItem.vue'], resolve),
				meta: { title: '宝可梦道具' },
			},
		]
	},
	{
		path: '/messageWall',
		component: resolve => require(['../components/common/messageWall.vue'], resolve),
		meta: { title: '公示墙' },
	},
	{
		path: '/updateAnnouncement',
		component: resolve => require(['../components/common/updateAnnouncement.vue'], resolve),
		meta: { title: '更新公告' },
	},
	{
		path: '/aboutUs',
		component: resolve => require(['../components/common/aboutUs.vue'], resolve),
		meta: { title: '关于我们' },
	},
	{
		path: '*',
		redirect: '/404'
	}
]

export default new Router({
	// mode: 'history', //后端支持可开
	base: "/website/",
	routes: constantRouterMap
})

export const asyncRouterMap = [

]




// WEBPACK FOOTER //
// ./src/router/index.js